import $ from 'jquery';
import scrollTo from '../utils/scroll-to';

import { MetaRouter } from '../utils/metarouter';
import { isLargeUp, isMedium } from '../utils/media-queries';

function getVideoElement() {
    return $('.pill-hero__video');
}

function getVideoUrl() {
    const $videoElement = getVideoElement();
    if (!$videoElement.length) {
        return undefined;
    }

    let videoUrl = $videoElement.data('small-video');
    if (isLargeUp()) {
        videoUrl = $videoElement.data('large-video');
    } else if (isMedium()) {
        videoUrl = $videoElement.data('medium-video');
    }
    return videoUrl;
}

function addVideoSource(videoUrl) {
    const $videoElement = getVideoElement();
    const source = document.createElement('source');
    source.type = 'video/mp4';
    source.src = videoUrl;
    $videoElement.append(source);
}

export default ($el) => {
    const videoUrl = getVideoUrl();
    if (videoUrl) {
        addVideoSource(videoUrl);
    }

    const type = $el.data('pill-type');
    if (type === 'super-collection') {
        const target = $el.data('pill-target');
        const $pills = $el.find('.pill-hero__pills__pill');

        $pills.on('click', (e) => {
            e.preventDefault();
            const val = e.target.value;

            const $filter = $(
                `#${target} .super-col__filter[data-age-range="${val}"]`,
            );

            MetaRouter.sendTrackEvent('module_item_tapped', {
                app: 'web-site',
                location_on_page: $el.attr('id'),
                screen_name: 'home_page',
                component: 'pill_hero',
                button_name: e.target.innerText,
            });

            $filter.trigger('click');
            scrollTo($(`#${target}`));
        });
    }

    const $ratings = $el.find('.pill-hero__ratings');
    const ratingsTarget = $ratings.data('ratings-target');

    if (ratingsTarget) {
        $ratings.on('click', (e) => {
            e.preventDefault();
            scrollTo($(`#${ratingsTarget}`));
        });
    }
};
